// Demo personas (data in fixtures/persona-*.json). Default plan per persona; the demo menu can override it.
import type { Plan } from '../../domain/types';
import type { PersonaId } from '../../fixtures/schema';

export type { PersonaId };

export const PERSONAS: { id: PersonaId; name: string; email: string; plan: Plan; blurb: string }[] = [
  { id: 'free-scan', name: 'Maya Chen', email: 'm•••n@gmail.com', plan: 'free_scan', blurb: 'First scan, details locked' },
  { id: 'basic-at-risk', name: 'Tom Walsh', email: 't•••h@outlook.com', plan: 'basic', blurb: '3 emails, reused password' },
  { id: 'upgrade-moment', name: 'Ines Duarte', email: 'i•••e@gmail.com', plan: 'basic', blurb: 'Basic, about to upgrade' },
  { id: 'complete-in-progress', name: 'Jonas Berg', email: 'j•••g@proton.me', plan: 'complete', blurb: 'Fixes under way' },
  { id: 'ultimate-healthy', name: 'Priya Nair', email: 'p•••r@icloud.com', plan: 'ultimate', blurb: 'Protected, 4-week streak' },
  { id: 'my-account', name: 'Eduardas Lavrinovičius', email: 'eduardaslavrinovicius@gmail.com', plan: 'complete', blurb: 'My account · real data' },
  { id: 'onboarding', name: 'Eduardas Lavrinovičius', email: 'eduardaslavrinovicius@gmail.com', plan: 'complete', blurb: 'New account · nothing scanned yet' },
];

export const DEFAULT_PERSONA: PersonaId = 'basic-at-risk';
export const personaById = (id: PersonaId) => PERSONAS.find((p) => p.id === id) ?? PERSONAS[1];
